































import {
  getMinValue,
  getMaxValue,
} from '@getaccept/editor-lib/src/helpers/pricing-table/pricing-table-units-modifier-menu.helper';
import { PricingTableHelper, UnitInputType } from '@getaccept/editor-lib';
import type { Field, NumberInputSettings } from '@getaccept/editor-lib';
import DropdownItemsWrapper from '@getaccept/editor-lib/src/components/DropdownItemsWrapper.vue';
import type { PropType } from '@vue/composition-api';
import { watch, defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'PricingTableUnitsModifierMenu',
  components: {
    DropdownItemsWrapper,
  },
  props: {
    inputField: {
      type: Object as PropType<Field & { inputSettings: NumberInputSettings }>,
      default: () => ({}),
    },
    open: { type: Boolean },
    disabled: { type: Boolean },
  },
  setup(props, { emit }) {
    const defaultValueError = ref('');

    watch(
      () => props.open,
      (open: boolean) => {
        if (!open) {
          return;
        }
        defaultValueError.value = '';
      }
    );

    const close = () => {
      emit('close');
    };

    const handleEsc = () => {
      close();
    };

    const handleEnter = (event: FocusEvent) => {
      handleDefaultValueBlur(event);
      if (defaultValueError.value === '') {
        close();
      }
    };

    const handleDefaultValueBlur = (event: FocusEvent) => {
      const rawValue = (event.target as HTMLInputElement).value;
      const numValue = Number(rawValue);
      const hasValueChanged = Number(props.inputField.value) !== numValue;
      const isValidValue = hasValueChanged && !isNaN(numValue) && !!rawValue;

      if (!isValidValue || defaultValueError.value) {
        return;
      }

      emit('update-field', { id: props.inputField.id, value: String(numValue) });
    };

    const handleDefaultValueChange = (value: string) => {
      const minValue = getMinValue(props.inputField);
      const maxValue = getMaxValue(props.inputField);

      if (minValue === null || maxValue === null || value === '') {
        defaultValueError.value = '';
      } else if (Number(minValue) > 0 && Number(value) < Number(minValue)) {
        defaultValueError.value = 'default-value-error-cant-be-lower-than-min-value';
      } else if (Number(maxValue) > 0 && Number(value) > Number(maxValue)) {
        defaultValueError.value = 'default-value-error-cant-be-higher-than-max-value';
      } else {
        defaultValueError.value = '';
      }
    };

    return {
      defaultValueError,
      close,
      handleEsc,
      handleEnter,
      handleDefaultValueBlur,
      handleDefaultValueChange,
      isKeyAllowed: PricingTableHelper.isKeyAllowed,
      UnitInputType,
      getMinValue,
      getMaxValue,
    };
  },
});
